import React from "react";
import PropTypes from "prop-types";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { DATE_FORMAT } from "utils/dateUtils";

function DatePicker({ value, onChange, helperText, error, ...rest }) {
    return (
        <KeyboardDatePicker
            {...rest}
            value={value}
            format={DATE_FORMAT}
            onChange={(momentDate) => onChange(momentDate ? momentDate._d : null)}
            helperText={error || helperText}
            error={Boolean(error)}
            autoOk
        />
    );
}

DatePicker.propTypes = {
    margin: PropTypes.string,
    fieldName: PropTypes.string.isRequired,
    helperText: PropTypes.string,
    fullWidth: PropTypes.bool,
    inputVariant: PropTypes.string,
    size: PropTypes.string,
    error: PropTypes.string,
    value: PropTypes.instanceOf(Date),
    onChange: PropTypes.func,
};

DatePicker.defaultProps = {
    margin: "normal",
    helperText: undefined,
    fullWidth: true,
    inputVariant: "outlined",
    size: "small",
    error: undefined,
    onChange: () => {},
    value: null,
};

export default DatePicker;
